import { TextField } from "@mui/material";
import * as React from "react";

export default function RedeemVoucherMicrochipNumber({
  row,
  mc,
  setMc,
  hideMicrochipNumber,
  microchips,
  mcWhyNot,
  updateValue,
}) {
  const [touched, setTouched] = React.useState(false); // Track if the field has been blurred at least once

  if (hideMicrochipNumber === true) return null;

  // Compute error after blur. Don't suppress when the value matches the initial value —
  // an initially-empty mandatory field must still show as invalid once touched.
  const hasError =
    touched &&
    (
      ((mc === "" || mc.length !== 15) && mcWhyNot === "") ||
      microchips.includes(mc) ||
      (["Microchip only"].includes(row.a_type_surgery) && mc === "")
    );

  return (
    <TextField
      error={hasError}
      size={"full"}
      value={mc}
      label={"Microchip number"}
      type="text"
      onBlur={(e) => {
        let d = String(e.currentTarget.value).replace(/\D/g, "");
        setTouched(true); // Mark field as touched on blur
        // Perform validation on blur and clear the field if the value is invalid:
        if (
          ((d === "" || d.length !== 15) && mcWhyNot === "") ||
          microchips.includes(d) ||
          (["Microchip only"].includes(row.a_type_surgery) && d === "")
        ) {
          d = "";
        }
        updateValue(d, "a_microchip_number");
        setMc(d);
      }}
      onChange={(e) => {
        // Update value without validating on every keystroke
        let d = String(e.currentTarget.value).replace(/\D/g, "");
        setMc(d);
      }}
      sx={{ width: "calc(100%)" }}
      helperText={
        microchips.includes(mc) ? (
          <b>This microchip number has been used before.</b>
        ) : (
          "Must be 15 digits long, and microchip number has not been used before."
        )
      }
      placeholder={mcWhyNot !== "" ? "Not required, reason stated below." : ""}
    />
  );
}
